export enum AdminAddStepTemplateFormItemLabel {
  Type = "Tip koraka",
  Name = "Naziv koraka",
  Description = "Opis",
  MessageText = "Tekst poruke",
  QuestionnaireId = "Odaberi upitnik",
}
